'use strict';

import {
    BufferGeometry,
    Group,
    TextureLoader,
    Float32BufferAttribute,
    PointsMaterial,
    AdditiveBlending, Points, PlaneBufferGeometry, ShaderMaterial, Mesh, Vector2, Scene, OrthographicCamera, Fog, Color,
} from 'three';
import { projectMode, threeJsVariables } from '../../settings';
import { PostFX } from '../post-processing/PostFX';
import snowVertex from '../threejs/Shaders/weather/snow/vertexShader.glsl';
import snowFragment from '../threejs/Shaders/weather/snow/fragmentShader.glsl';
import { basic_tile } from '../threejs/environment';

// export class Snow {
//
//     static #instances = [];
//     static #group = new Group();
//
//     #geometry = new BufferGeometry();
//     #material;
//     #particles;
//     #texture;
//     #gravity;
//     #vertices = [];
//
//     constructor (count, img, area, snowSize, color) {
//         this.count = count;
//         this.area = area;
//         this.snowSize = snowSize;
//         // this.#gravity = ((Math.random() * (1 - 0.05)) + 0.05);
//         this.#gravity = ((Math.random() * (3 - 1)) + 1);
//         this.#texture = typeof img === 'string' ? new TextureLoader().load(img) : img;
//
//         for (let i = 0; i < this.count; i++) {
//             const x = Math.random() * this.area * 2 - this.area;
//             const y = Math.random() * this.area * 2 - this.area;
//             const z = Math.random() * this.area * 2 - this.area;
//
//             this.#vertices.push(x,y,z);
//         }
//
//         this.#geometry.setAttribute('position', new Float32BufferAttribute(this.#vertices,3));
//
//         this.#material = new PointsMaterial({
//             size: this.snowSize,
//             map: this.#texture,
//             blending: AdditiveBlending,
//             depthTest: false,
//             transparent: true,
//         });
//
//         this.#material.color.setHex(color);
//         this.#particles = new Points(this.#geometry,this.#material);
//
//         Snow.#instances.push(this);
//         Snow.#group.add(this.#particles);
//     }
//
//     update(delta) {
//         this.#particles.position.y -= this.#gravity;
//         // this.#particles.position.x += 0.5 - Math.sin(delta);
//
//         // this.#particles.rotation.y += 0.002;
//
//         if (this.#particles.position.y <= - this.area){
//             this.#particles.position.y += this.area * 2;
//         }
//
//     }
//
//     static updateSnowPhysics(delta) {
//         Snow.#instances.forEach(instance => instance.update(delta));
//     }
//
//     static addToScene() {
//         Snow.#group.name = 'Snow';
//         threeJsVariables.scene.add(Snow.#group);
//     }
//
// }


export class Snow {

    constructor () {
        this.fogColor = new Color(0.87,0.87,0.87);
        this.envFogDensity = 0.0025;
        this.bgFogDensity = 0.0025;

        this.material = new ShaderMaterial({
            vertexShader: snowVertex,
            fragmentShader: snowFragment,
            uniforms: {
                uTime: {
                    value: 0
                }
            }
        });

        this.effect = new PostFX('snow',threeJsVariables.renderer,this.material);

        return this;
    }

    enable() {
        this.effect.enable();

        if (!projectMode.LiteMode.isActive()) {
            /* ENV FOG */
            basic_tile.uniforms.fogColor.value.copy(this.fogColor);
            basic_tile.uniforms.fogDensity.value = this.envFogDensity;

            if (threeJsVariables.tilesRenderer){
                threeJsVariables.tilesRenderer.forEachLoadedModel((scene,tile)=>{
                    scene.traverse(obj => {
                        if ( obj.material) {
                            obj.material.uniforms.fogColor.value.copy(this.fogColor);
                            obj.material.uniforms.fogDensity.value = this.envFogDensity;
                        }
                    });
                });
            } else {
                let env = threeJsVariables.scene.getObjectByName('async env');
                env.traverse(obj => {
                    if ( obj.material) {
                        obj.material.uniforms.fogColor.value.copy(this.fogColor);
                        obj.material.uniforms.fogDensity.value = this.envFogDensity;
                    }
                });
            }

            /* BG FOG */
            const bg = threeJsVariables.scene.getObjectByName('Background');
            bg.traverse(obj => {
                if (obj.material) {
                    obj.material.uniforms.fogColor.value.copy(this.fogColor);
                    obj.material.uniforms.fogDensity.value = this.bgFogDensity;
                }
            });

            /* SCENE FOG */
            threeJsVariables.scene.fog = new Fog(new Color().copy(this.fogColor),1.0,725);

        } else {
            projectMode.LiteMode.cloudsToggle('enable');
        }
    }

    disable() {
        this.effect.disable();

        if (!projectMode.LiteMode.isActive()) {
            /* ENV FOG */
            basic_tile.uniforms.fogDensity.value = 0.0;

            if (threeJsVariables.tilesRenderer){
                threeJsVariables.tilesRenderer.forEachLoadedModel((scene,tile)=>{
                    scene.traverse(obj => {
                        if ( obj.material) {
                            obj.material.uniforms.fogDensity.value = 0.0;
                        }
                    });
                });
            } else {
                let env = threeJsVariables.scene.getObjectByName('async env');
                env.traverse(obj => {
                    if ( obj.material) {
                        obj.material.uniforms.fogDensity.value = 0.0;
                    }
                });
            }

            /* BG FOG */
            const bg = threeJsVariables.scene.getObjectByName('Background');
            bg.traverse(obj => {
                if (obj.material) {
                    obj.material.uniforms.fogDensity.value = 0.0;
                }
            });

            /* SCENE FOG */
            threeJsVariables.scene.fog = null;
        } else {
            projectMode.LiteMode.cloudsToggle('disable');
        }
    }

    update(time) {
        if (this.effect.active) {
            this.material.uniforms.uTime.value = time;
        }
    }
}